






















import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'CpToast',
  props: {
    variant: {
      type: String as PropType<'success' | 'info' | 'error'>,
      required: true,
      default: 'success',
    },
    hide: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
})
